import React from 'react';
import css from './SeoPage.module.css';
import { useIntl } from 'react-intl';

const CTASection = props => {
  const intl = useIntl();
  return (
    <section className={css.ctaWrapper}>
      <h2 className={css.ctaTitle}>{intl.formatMessage({ id: 'General.cta.title' })}</h2>
      <p className={css.ctaDescription}>{intl.formatMessage({ id: 'General.cta.description' })}</p>
      <a className={css.ctaButton} href="/s">
        {intl.formatMessage({ id: 'General.cta.button' })}
      </a>
    </section>
  );
};

export default CTASection;
